import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';
import { Globals } from './globals';
import { TranslateModule } from '@ngx-translate/core';
import {
  AccordionAnchorDirective,
  AccordionDirective,
  AccordionLinkDirective,
} from './accordion';
import { RoundDecimalsDirective } from './directives/round-decimals.directive';
import { CommonYesNoDialogComponent } from './dialogs/common-yes-no-dialog.component';
import { CardTerminalAdminPinDialogComponent } from './dialogs/card-terminal-admin-pin-dialog.component';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material-module';
import { LicenseInformationContentComponent } from './license-information/license-information-content.component';
import { StickySearchHeaderComponent } from './sticky-search-header.component';
import { FormsModule } from '@angular/forms';
import { TableComponent } from './table.component';
import { ButtonComponent } from './button.component';
import { DialogComponent } from './dialog.component';
import { CardComponent } from './card.component';
import { DeleteDialogComponent } from './delete-dialog.component';
import { RouterLink } from '@angular/router';
import { FeedbackOverlayComponent } from './feedback-overlay/feedback-overlay.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    MatCardModule,
    TranslateModule,
    FormsModule,
    RouterLink,
  ],
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ButtonComponent,
    CardComponent,
    CardTerminalAdminPinDialogComponent,
    CommonYesNoDialogComponent,
    DeleteDialogComponent,
    DialogComponent,
    LanguageSelectorComponent,
    LicenseInformationContentComponent,
    RoundDecimalsDirective,
    StickySearchHeaderComponent,
    TableComponent,
    FeedbackOverlayComponent,
  ],
  exports: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    ButtonComponent,
    CardComponent,
    CardTerminalAdminPinDialogComponent,
    DeleteDialogComponent,
    DialogComponent,
    LanguageSelectorComponent,
    RoundDecimalsDirective,
    TranslateModule,
    LicenseInformationContentComponent,
    StickySearchHeaderComponent,
    TableComponent,
    FeedbackOverlayComponent,
  ],
  providers: [MenuItems, Globals],
})
export class SharedModule {}
